import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  entity!: FormGroup;
  formMethod = 'CREATE';
  provider: any;

  constructor(
    private fb: FormBuilder,
  ) {}

  nonEmptyValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value.trim().length === 0) {
      return { nonEmpty: 'Este campo no puede estar vacío' };
    }
    return null;
  }

  onlyLettersValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const valid = /^[a-zA-Z\p{L}\s.]*$/u.test(value);
    if (!valid) {
      return { onlyLetters: 'Solo se permiten letras' };
    }
    return null;
  }

  newEntity() {
    switch (this.formMethod) {
      case 'CREATE':
        this.entity = this.fb.group({
          fullName: ['', [Validators.required, Validators.minLength(3), this.onlyLettersValidator]],
          rfc: ['', [Validators.required, Validators.pattern(/^[A-ZÑ&]{3,4}\d{6}[A-Z\d]{3}$/)]],
          sector: ['', [Validators.required, this.nonEmptyValidator]],
          subSector: ['', [Validators.required, this.nonEmptyValidator]],
        });
        break;
      case 'EDIT':
        this.entity = this.fb.group({
          fullName: [this.provider.fullName, [Validators.required, Validators.minLength(3), this.onlyLettersValidator]],
          rfc: [this.provider.rfc, [Validators.required, Validators.pattern(/^[A-ZÑ&]{3,4}\d{6}[A-Z\d]{3}$/)]],
          sector: [this.provider.sector, [Validators.required, this.nonEmptyValidator]],
          subSector: [this.provider.subSector, [Validators.required, this.nonEmptyValidator]],
          status: [this.provider.status, [Validators.required]],
        });
        break;
    }
  }
}
